<template>
	<div class="homeBox" v-cloak>
    <!-- <topShadow></topShadow> -->
		<!-- 背景是图片 -->
		 <div class="swiper-container">
          <div class="swiper-wrapper">
            <div v-for='(i,index) in arrItem' :key='index' :txt="i.details" class="swiper-slide" ref="swiperS">
              <div class="iSlide">
                  <img class="img" :src="i.url">
                </div>
            </div>
          </div>
          <div class="btnBox">
              <div class="swiper-button-prev"></div>
              <div class="swiper-button-next"></div>
              <div class="describeBtn" @click="txtShow"></div>
              <div class="describeBox" v-show="isShowTxtBox"><p ref="describeBoxP"></p><i></i></div>
          </div>
          <div class="homeBotTxt">
            <p>Copyright ©2018 思考乐教育</p>
            <div>
              <router-link to="/LegalDeclaration" @click.native="changeHeadNavList">法律声明</router-link>
              <span class="l">|</span>
              <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}" @click.native="changeHeadNavList">校区导航</router-link>
            </div>
          </div>

      </div>
	</div>
</template>
<script>
import Swiper from 'swiper'
import '../../../node_modules/swiper/dist/css/swiper.css'
import '../../../node_modules/swiper/dist/css/swiper2.min.css'

export default {

  name: 'Home',
  data(){
    return {
       indexStrArr: ["第一页","第二页","第三页","第四页"],//首页文字数组
       // nowIndex: 0,//当前第几页
       isShowTxtBox: false,
       arrItem:[]
    }
  },
  created(){
      this.axios.get(this.$root.baseUrl+'/wap/home/list')
      .then(res=>{
        this.arrItem = res.data
      })
      .catch(e=>{
        console.log(e)
      })
  },
  mounted:function(){
    var that = this;
    this.$nextTick(function(){
          var mySwiper = new Swiper('.swiper-container', {
              effect : 'fade',
              // activeIndex: 1,
              autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
              },
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
              observer:true,//修改swiper自己或子元素时，自动初始化swiper
              observeParents:true,//修改swiper的父元素时，自动初始化swiper
              loop:true,
              slidesPerView: 'auto'
          })
    })

  },
  methods: {
    txtShow: function(){
      console.log(document.getElementsByClassName('swiper-slide-active')[0])
      if(document.getElementsByClassName('swiper-slide-active')[0].getAttribute('txt')){
        this.$refs.describeBoxP.innerHTML = document.getElementsByClassName('swiper-slide-active')[0].getAttribute('txt');
        this.isShowTxtBox = !this.isShowTxtBox;
      }else{
        this.isShowTxtBox = false;
      }
    },
    changeHeadNavList:function(e){
      console.log(e)
      e.cancelBubble = true;
      document.getElementById("navLinkBox").classList.remove('active');
      document.getElementById("navLinkBox").style.transition = "0.5s";
    }
  }
}
</script>
<style scoped>
.btnBox{
  position: fixed;
  z-index: 999;
  width: 15rem;
  height: 2.3rem;
  bottom: 6.3333rem;
  margin: 0 auto;
  left: 0;
  right: 0;
  text-align: center;
}
.iSlide{
  height: 100%;
  width: 100%;
}
.iSlide img{
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next {
    right: 0;
    /* left: auto; */
    top: auto;
    bottom: 0;
    width: 2.333rem;
    height: 2.333rem;
    border-radius: 50%;
    position: static;
    display: inline-block;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev {
    bottom: 0;
    width: 2.333rem;
    height: 2.333rem;
    border-radius: 50%;
    position: static;
    display: inline-block;
    margin: 0 0.3rem;
}
.describeBtn {
    width: 2.333rem;
    height: 2.333rem;
    position: static;
    display: inline-block;
    background-image: url(../../../node_modules/swiper/dist/img/i.png);
    background-size: 100% 100%;
    cursor: pointer;
}
.describeBox {
    width: 93%;
    min-height: 16rem;
    position: absolute;
    bottom: 4rem;
    background: #333;
    color: #fff;
    right: 0;
    z-index: 99;
    padding: 0.7rem;
    opacity: 0.7;
/*    display: none; */
    box-sizing: border-box;
}
.describeBox i {
    width: 1.2rem;
    height: 1.2rem;
    position: absolute;
    transform: rotate(45deg);
    -ms-transform: rotate(45deg);
    -moz-transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    -o-transform: rotate(45deg);
    bottom: -0.6rem;
    right: 4rem;
    background: #333;
}
.describeBox p{
  text-align: left!important;
}
.homeBotTxt{
    position: fixed;
    bottom: 1rem;
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #fff;
    font-weight: 100;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
}
.homeBotTxt a{
    color: #fff;
    text-decoration: underline;
    font-weight: 100;
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
}
.btnBox .swiper-button-next{
  position: static!important;
  width: 2.333rem!important;
  height: 2.333rem!important;
}
.btnBox .swiper-button-prev{
  position: static!important;
  width: 2.333rem!important;
  height: 2.333rem!important;
}
[v-cloak]{ display :none }
</style>



// WEBPACK FOOTER //
// src/components/home/Home.vue